(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["edx-chan-da"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var box = root.querySelector('[data-edx-cd]');
      if (!box || box.dataset.ready) return;
      box.dataset.ready = '1';
      root.classList.add('is-js');
      var qs = Array.prototype.slice.call(box.querySelectorAll('.edx-cd__q'));
      var bars = box.querySelectorAll('.edx-cd__steps i');
      var next = box.querySelector('[data-next]');
      var back = box.querySelector('[data-back]');
      var zaloBtn = box.querySelector('[data-zalo-btn]');
      var result = box.querySelector('[data-result]');
      var sum = box.querySelector('[data-sum]');
      var colLink = box.querySelector('[data-col-link]');
      var copied = box.querySelector('[data-copied]');
      var step = 0;
      function val(i) { var c = qs[i].querySelector('input:checked'); return c; }
      function show() {
        qs.forEach(function (q, i) { q.classList.toggle('is-active', i === step); });
        for (var b = 0; b < bars.length; b++) bars[b].classList.toggle('is-on', b <= Math.min(step, 2));
        var done = step >= qs.length;
        next.hidden = done;
        next.disabled = !done && !val(step);
        back.hidden = step === 0;
        zaloBtn.hidden = !done;
        result.hidden = !done;
        if (done) {
          var a = val(0), c = val(1), d = val(2);
          var msg = 'Chào shop, da em ' + a.value.toLowerCase() + ', bận tâm ' + c.value.toLowerCase() + ', ngân sách ' + d.value.toLowerCase() + '. Bé gợi ý giúp em.';
          sum.textContent = msg;
          zaloBtn.dataset.msg = msg;
          var col = c.dataset.col || a.dataset.col;
          if (a.dataset.col === 'da-nhay-cam') col = 'da-nhay-cam';
          if (col) { colLink.href = '/collections/' + col; colLink.hidden = false; } else { colLink.hidden = true; }
        }
      }
      box.addEventListener('change', function () { next.disabled = !val(step); });
      next.addEventListener('click', function () { if (val(step)) { step++; show(); } });
      back.addEventListener('click', function () { if (step > 0) { step--; copied.hidden = true; show(); } });
      zaloBtn.addEventListener('click', function () {
        var m = zaloBtn.dataset.msg;
        if (m && navigator.clipboard) { navigator.clipboard.writeText(m).then(function () { copied.hidden = false; }).catch(function () {}); }
      });
      show();
    }
    function all() { document.querySelectorAll('.edx-cd').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', all);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edx-zalo-noi"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var link = document.getElementById('zalo-btn');
    if (!link) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    try {
      if (sessionStorage.getItem('edxZaloNudge')) return;
      sessionStorage.setItem('edxZaloNudge', '1');
    } catch (e) {}
    setTimeout(function () {
      link.classList.add('edx-zalo__link--nudge');
    }, 6000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
